import { render, staticRenderFns } from "./anchorMonitor.vue?vue&type=template&id=b08816dc&scoped=true&"
import script from "./anchorMonitor.vue?vue&type=script&lang=js&"
export * from "./anchorMonitor.vue?vue&type=script&lang=js&"
import style0 from "./anchorMonitor.vue?vue&type=style&index=0&id=b08816dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08816dc",
  null
  
)

export default component.exports